import React, { Component } from 'react';
import _ from 'underscore';

export default class extends Component {
    playAudio() {
        this.refs.audioEl && this.refs.audioEl.play();
    }

    render() {
        let props = _.clone(this.props);

        return (
            <audio ref='audioEl' {...props}></audio>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/audio/index.js